import type { FC } from 'react'
import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import ImproveYourAdsImage from './ImproveYourAdsImage'

const copy = {
  overline: `Why Segment and Facebook`,
  heading: `Improve your ads with the right message`,
  description: `Segment enables businesses using Facebook ad products to improve their targeting and deliver relevant content to the right person, at the right time, in the right place.`,
}

const ImproveYourAds: FC = () => (
  <Wrapper>
    <StyledSectionBase variant="2Col">
      <SectionCopy>
        <CopyTextBase>
          <StyledOverline tag="h4" variant="textBold">
            {copy.overline}
          </StyledOverline>
          <CopyText.Heading variant="h2" tag="h3">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pLarge">{copy.description}</CopyText.Description>
        </CopyTextBase>
      </SectionCopy>

      <Section.Contents>
        <ImproveYourAdsImage />
      </Section.Contents>
    </StyledSectionBase>
  </Wrapper>
)

const Wrapper = styled.section`
  display: grid;

  ${({ theme }) => theme.breakpoints.down(`md`)} {
    padding-top: 20px;
  }

  ${({ theme }) => theme.breakpoints.up(`xl`)} {
    margin-top: 100px;
  }
`

const StyledSectionBase = styled(SectionBase)`
  overflow: visible;
`

const StyledOverline = styled(CopyText.Overline)``

const SectionCopy = styled(Section.Copy)`
  display: flex;
  align-items: center;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 392px;
    justify-self: end;
    align-self: center;
  }
`

export default ImproveYourAds
